import { Interval } from "luxon";

export const fillMonths = (start, end) =>
  Interval
    .fromDateTimes(start, end)
    .splitBy({ months: 1 })
    .map(interval => interval.start);
